import { combineReducers } from "redux";

import { classification } from "./classification";
import { upload } from "./upload";

export const documents = combineReducers({
  classification,
  upload
});

export default documents;
